import React from "react";
import { Link } from "react-router-dom";
import Star from "../assets/icons/Star";
import Location from "../assets/icons/Location";

const RestaurantListCard = ({ props }) => {
  return (
    <Link to={`/all-restaurants/detail?id=${props._id}`} className="rest_name">
      {
        <div className="rest_card">
      <div className="rest_img">
        <img src={props.restaurant_banner[0]} alt={props.company_name} />
        <span className="rest_stars">
          <Star />
          {props.rating}
        </span>
      </div>
      {props.offer && <span className="rest_ribbon">{props.offer}</span>}
      <div className="rest_detail">
        {/* <Link to='/all-restaurants/detail/${props._id}' className="rest_name">
          {props.company_name}
        </Link> */}
        
        {props.restaurant_name}

        <p className="rest_desc">{props.description}</p>
        <div className="rest_location_flex">
          <Location />
          {props.company_address}
        </div>
      </div>
    </div>
      }
    </Link>
  );
};

export default RestaurantListCard;
